import React, { useState } from "react";
import AppEn from "./components/AppEn";
import AppId from "./components/AppId";

const App = () => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("language") || "en";
  });

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return language === "en" ? (
    <AppEn currentLanguage={language} onChangeLanguage={handleLanguageChange} />
  ) : (
    <AppId currentLanguage={language} onChangeLanguage={handleLanguageChange} />
  );
};

export default App;

